

export default {
    name: 'JdRecomList',
    props: {
        jds: Array,
    },
}
